const colorSet = {
  // Primary
  primary: '#5628F5',
  primary100: '#FDFCFF',
  primary200: '#EAE6FC',
  primary300: '#B2A2F3',
  primary400: '#7A5EEB',
  primary500: '#420AE0',
  primary600: '#280689',
  primary700: '#1D0462',
  primary800: '#0C0227',

  // Secondary
  secondary: '#0F71FF',
  secondary100: '#F5F9FF',
  secondary200: '#D6E7FF',
  secondary300: '#74AEFF',
  secondary400: '#428FFF',
  secondary500: '#0059DB',
  secondary600: '#0045A8',
  secondary700: '#003075',
  secondary800: '#001B42',

  // Gray - Earth
  gray50: '#F7F9FA',
  gray75: '#F1F4F6',
  gray100: '#E7EDF0',
  gray200: '#CFD6D9',
  gray300: '#AEB7BC',
  gray400: '#6E777C',
  gray500: '#5E696E',
  gray600: '#4A5256',
  gray700: '#353C3F',
  gray800: '#222729',

  // Gray
  gray0: '#F8FAFB',
  gray1: '#F1F3F5',
  gray2: '#DEE2E6',
  gray3: '#CED4DA',
  gray4: '#ADB5BD',
  gray5: '#868E96',
  gray6: '#626C75',
  gray7: '#495057',
  gray8: '#343A40',
  gray9: '#1A1D20',

  // Blue
  blue0: '#F2F9FF',
  blue1: '#E5F2FF',
  blue2: '#B3D7FF',
  blue3: '#66AFFF',
  blue4: '#3395FF',
  blue5: '#007AFF',
  blue6: '#005CE1',

  // Blue-Leagcy
  blue7: '#166DD7',
  blue8: '#1150AA',
  blue9: '#0B3E91',

  // Red
  red: '#FF334B',
  red0: '#FFF5F5',
  red1: '#FFEDEF',
  red2: '#FCC5CB',
  red3: '#FF96A3',
  red4: '#FF697A',
  red5: '#E5172F',

  // Orange
  orange: '#FF9500',
  orange0: '#FFF9DB',
  orange1: '#FFF4E5',
  orange2: '#FFDFB3',
  orange3: '#FFBF66',
  orange4: '#FFAA33',
  orange5: '#E17700',

  // Yellow
  yellow: '#FFCC00',
  yellow0: '#FFFDE5',
  yellow1: '#FFF7D9',
  yellow2: '#FFF0B3',
  yellow3: '#FFE066',
  yellow4: '#FFD633',
  yellow5: '#E1AE00',

  // Green
  green: '#15BD66',
  green0: '#F2FFD7',
  green1: '#EBFAEF',
  green2: '#93EDBF',
  green3: '#64E8A4',
  green4: '#35DB80',
  green5: '#18A352',

  // Pink - Leagcy
  pink: '#E0275F',
  pink0: '#FFECF2',
  pink1: '#FFD8E4',
  pink2: '#FF9EBB',
  pink3: '#FF81A6',
  pink4: '#F54E80',
  pink5: '#C20C43',

  // Purple
  purple: '#8556E3',
  purple0: '#FFEBFF',
  purple1: '#F3D9FA',
  purple2: '#D4C4F5',
  purple3: '#BD9FF5',
  purple4: '#A17DF5',
  purple5: '#6B3CC9',

  white: '#FFFFFF',
} as const;

export default colorSet;

type ColorType = keyof typeof colorSet;
export { type ColorType };
